import { render, staticRenderFns } from "./SalesModuleLayout.vue?vue&type=template&id=68efe0d0"
import script from "./SalesModuleLayout.vue?vue&type=script&lang=js"
export * from "./SalesModuleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports